const rules = [
  // if it says it's a webview, let's go with that
  'WebView',
  // iOS webview will be the same as safari but missing "Safari"
  '(iPhone|iPod|iPad)(?!.*Safari)',
  // https://developer.chrome.com/docs/multidevice/user-agent/#webview_user_agent
  'Android.*Version/[0-9].[0-9]',
  // Also, we should save the wv detected for Lollipop
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  'Android.*wv',
  // old chrome android webview agent
  'Linux; U; Android',
];

const isWebView = (userAgent: string) => {
  const webviewRegExp = new RegExp('(' + rules.join('|') + ')', 'ig');
  return !!userAgent.match(webviewRegExp);
};

/**
 * Checks whether the user is hasn't ability to login via google/linedin.
 * Because some applications don't support OAuth in WebView (eg linkedin, tiktok).
 *
 * @param referrer {@link document.referrer}
 * @param userAgent {@link navigator.userAgent}
 * @param isWebViewDevice From $device plugin, just double check
 **/
export function isUserInsideExternalApp(
  referrer: string = document.referrer,
  userAgent: string = navigator.userAgent,
  isWebViewDevice = false,
) {
  const isLinkedin = referrer.includes('com.linkedin') || userAgent.includes('LinkedInApp');
  const isTikTok =
    userAgent.includes('TikTok') ||
    referrer.includes('com.ss.android.ugc.trill') ||
    referrer.includes('com.zhiliaoapp');

  return isLinkedin || isTikTok || isWebView(userAgent) || isWebViewDevice;
}
